import ApplicationSimpleView from './ApplicationSimpleView'

export default ApplicationSimpleView
